import { GetterTree } from 'vuex';
import { UiState, RootState } from '../types';

export const getters: GetterTree<UiState, RootState> = {
	/**
	 * Get the current state of the mobile navigation
	 *
	 * @param {UiState} state - The current UI state
	 * @return {boolean} - The state of the mobile navigation
	 */
	isMobileNavOpen(state): boolean {
		return state.mobileNavOpen;
	},

	/**
	 * Get the current state of the desktop navigation expanded state
	 *
	 * @param {UiState} state
	 * @return {boolean}
	 */
	isDesktopNavExpanded(state): boolean {
		return state.desktopNavExpanded;
	}
};